/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Search(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24.000000000000004'
                width='24.000000000000004'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    id='svg_9'
                    stroke='null'
                >
                    <g
                        id='svg_5'
                        stroke='null'
                        transform='matrix(0.9285615403962447,0,0,0.9208388734299814,2.7766321592676846,5.657213032815218) '
                    >
                        <g
                            id='svg_6'
                            stroke='null'
                        >
                            <path
                                d='m22.003904,17.564093l-5.69,-5.83a1.14,1.14 0 0 0 -0.23,-0.15a10.46,10.46 0 1 0 -1.43,1.4a0.83,0.83 0 0 0 0.15,0.23l5.69,5.82a1.06,1.06 0 0 0 0.75,0.32a1.06,1.06 0 0 0 0.76,-1.79zm-23.41,-12.75a9.51,9.51 0 1 1 9.49,9.51a9.53,9.53 0 0 1 -9.49,-9.51z'
                                fill={iconColor || '#000'}
                                id='svg_8'
                                stroke='null'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}